import { FC } from "react";
import { FormControl, FormItem, FormLabel, FormMessage } from "./ui/form";
import { cn } from "@/utils/utils";
import { ControllerRenderProps } from "react-hook-form";

interface Props {
  label: string;
  options: { value: string; label: string }[];
  field: ControllerRenderProps<any>;
  isMultiValue?: boolean;
}

const FormBadge: FC<Props> = ({ label, options, field, isMultiValue }) => {
  const handleUpdate = (value: string) => {
    if (!isMultiValue) {
      field.onChange(value);
      return;
    }

    const index = field.value?.indexOf(value);
    if (index === -1) {
      field.onChange([...field.value, value]);
    } else {
      field.onChange(field.value?.filter((v: string) => v !== value));
    }
  };

  const isSelected = (value: string) => {
    if (!isMultiValue) {
      return field.value === value;
    }

    return field.value?.includes(value);
  };

  return (
    <FormItem className="shadow-none drop-shadow-none">
      <FormLabel className="m-0 p-0 pb-2 text-[14px] text-[#6F7582]">
        {label}
      </FormLabel>
      <FormControl>
        <div className="flex gap-2">
          {options.map((option) => (
            <div
              className={cn(
                "border rounded-full py-1 px-3 cursor-pointer text-[12px] font-medium flex justify-center items-center text-center gap-2",
                isSelected(option.value)
                  ? "bg-[#757eb6]"
                  : "bg-white"
              )}
              onClick={() => handleUpdate(option.value)}
              key={option.value}
            >
              <p className="m-0 p-0">{option.label}</p>
              {isSelected(option.value) && isMultiValue && (
                <p className="m-0 p-0 font-semibold">x</p>
              )}
            </div>
          ))}
        </div>
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};

export default FormBadge;
